import { FC } from 'react';

import { CategoryContentProps } from './types';
import { TrackedPhoneNumber } from '@/components/TrackedPhoneNumber';

const Content: FC<CategoryContentProps> = ({ location }) => (
  <>
    <h2>
      {`CallAPro: We service${location || ' your city'} and surrounding areas. Our experts provide full service repairs, maintenance and installation of most windows. Call `}
      <TrackedPhoneNumber />
      {' to get a quote started.'}
    </h2>
    <section>
      <h3>Types of Windows</h3>
      <p>{`Our${location} window installers work with all different types of windows including:`}</p>
      <ul>
        <li>Double Hung</li>
        <li>Venting</li>
        <li>Sliding Windows</li>
        <li>Sliding Doors</li>
        <li>Bay Windows</li>
        <li>Bow Windows</li>
        <li>Garden Windows</li>
        <li>Picture Windows</li>
        <li>Specialty Shapes</li>
      </ul>
    </section>
    <section>
      <h3>Quick Turnaround Time:</h3>
      <p>
        {`Our${location} window installers can often replace and repair all the windows in your home in as little as one day. Make sure you ask about our turn around time, from repairs to full replacements, our window installers strive to be as fast and efficient as possible.`}
      </p>
      <p>
        {'Call us on '} <TrackedPhoneNumber />
      </p>
    </section>
    <section>
      <h3>Quality Services:</h3>
      <p>{"Being fast and efficient isn't worth much if you don't receive a quality window. Make sure to ask about our satisfied customers and here what others have had to say."}</p>
      <p>
        {'Call us on '} <TrackedPhoneNumber />
      </p>
    </section>
  </>
);

export default Content;
